/* SessionAgent.tsx generated by @compiled/babel-plugin v3.0.2 */
import { ax, ix } from "@compiled/react/runtime";
require("@compiled/webpack-loader/css-loader!@compiled/webpack-loader/css-loader/compiled-css.css?style=._3iDTPbccYA%7Bdisplay%3Ainline-flex%7D%0A._0hPCNLDIqT%7Balign-items%3Acenter%7D%0A._3YEZNOdnbC%7Bflex-shrink%3A0%7D%0A._2mHwu81Y8M%7Bgap%3Avar(--ds-space-050%2C4px)%7D%0A._2mHwu82ADO%7Bgap%3Avar(--ds-space-100%2C8px)%7D%0A._0GTcwR2ADO%7Bmargin-inline-start%3Avar(--ds-space-100%2C8px)%7D%0A._39xV02xpxF%7Bwidth%3A9pt%7D%0A._0jFU0VxpxF%7Bheight%3A9pt%7D%0A._39xV02ey7F%7Bwidth%3A1pc%7D%0A._0jFU0Vey7F%7Bheight%3A1pc%7D%0A._39xV02oWWg%7Bwidth%3A24px%7D%0A._0jFU0VoWWg%7Bheight%3A24px%7D%0A._1VJPcaTCRo%7Btransform%3Ascale(.75)%7D%0A._0yKXXaDIqT%7Btransform-origin%3Acenter%7D");













import React from 'react';
import { useIntl } from 'react-intl';
import { cx } from '@atlaskit/css';
import { RovoIcon } from '@atlaskit/logo/rovo/icon';
import { fg } from '@atlaskit/platform-feature-flags/fg';
import { Box } from '@atlaskit/primitives/compiled/box';
import { Flex } from '@atlaskit/primitives/compiled/flex';
import { Text } from '@atlaskit/primitives/compiled/text';
import { AgentAvatar } from '@atlaskit/rovo-agent-components/ui/AgentAvatar';
import { messages } from './messages';
const styles = {
  agent: "_3iDTPbccYA _0hPCNLDIqT _3YEZNOdnbC",
  identity: "_2mHwu81Y8M _3iDTPbccYA _0hPCNLDIqT",
  identityWithWideNameSpace: "_2mHwu82ADO _3iDTPbccYA _0hPCNLDIqT",
  spaced: "_0GTcwR2ADO",
  icon: "_3YEZNOdnbC",
  icon12: "_39xV02xpxF _0jFU0VxpxF",
  icon16: "_39xV02ey7F _0jFU0Vey7F",
  icon24: "_39xV02oWWg _0jFU0VoWWg",
  agentAvatar12: "_3iDTPbccYA _1VJPcaTCRo _0yKXXaDIqT"
};
export type SessionIconSize = 12 | 16;
export type AgentIdentityIconSize = SessionIconSize | 24;
export type SessionAgentDetails = {
  id: string;
  name: string;
  /** Raw signal that this identity represents the default Rovo agent. */
  isRovo?: boolean;
  avatarUrl?: string;
  agentId?: string;
  agentIdentityAccountId?: string;
  agentNamedId?: string;
};
export type SessionAgentProps = {
  agents: ReadonlyArray<SessionAgentDetails>;
  /** Whether to render visible agent names alongside their avatars. */
  showNames?: boolean;
  /** Compatibility override for callers that cannot yet provide `agent.isRovo`. */
  isDefaultAgent?: boolean;
  /** Visual size for agent icons. Defaults to 12. */
  iconSize?: SessionIconSize;
  /** Spacing between a visible agent icon and name. Defaults to `space.050`. */
  agentNameSpacing?: 'space.050' | 'space.100';
  additionalAgentCount?: number;
  testId?: string;
};
export type AgentIdentityIconProps = Readonly<{
  agent: SessionAgentDetails;
  iconSize?: AgentIdentityIconSize;
  /** Compatibility override for callers that cannot yet provide `agent.isRovo`. */
  isDefaultAgent?: boolean;
  /** Hides the icon from assistive technologies when its adjacent label supplies the name. */
  isDecorative?: boolean;
}>;

/**
 * Renders one agent's visual identity using the shared default-Rovo and specialist-avatar policy.
 */
export const AgentIdentityIcon = ({
  agent,
  iconSize = 16,
  isDefaultAgent = false,
  isDecorative = false
}: AgentIdentityIconProps): React.JSX.Element => {
  // Keep avatar geometry consistent for every shared consumer. The ADS gate coordinates
  // it with the backend avatar-image rollout, while AI Inbox gates the new visual treatment.
  const useAdsAvatar = fg('rovo-chat-ai-inbox') && fg('platform-dst-avatar-updated-geometry');
  const shouldUseRovoIcon = agent.isRovo ?? isDefaultAgent;
  const rovoIconSize = iconSize === 12 ? '12' : iconSize === 16 ? '16' : '24';
  const agentAvatar = <AgentAvatar size={iconSize === 24 ? 'small' : 'xxsmall'} imageUrl={agent.avatarUrl} name={agent.name} agentId={agent.agentId} agentIdentityAccountId={agent.agentIdentityAccountId} agentNamedId={agent.agentNamedId} UNSAFE_useAdsAvatar={useAdsAvatar} />;
  if (shouldUseRovoIcon) {
    return <Flex as="span" xcss={cx(styles.icon, iconSize === 12 ? styles.icon12 : iconSize === 16 ? styles.icon16 : styles.icon24)} alignItems="center" justifyContent="center" aria-hidden={isDecorative ? true : undefined}>
				<RovoIcon label={isDecorative ? '' : agent.name} size={rovoIconSize} />
			</Flex>;
  }
  return <Flex as="span" xcss={cx(styles.icon, iconSize === 12 ? styles.icon12 : iconSize === 16 ? styles.icon16 : styles.icon24)} alignItems="center" justifyContent="center" role={isDecorative ? undefined : 'img'} aria-label={isDecorative ? undefined : agent.name} aria-hidden={isDecorative ? true : undefined}>
			{iconSize === 12 ? <Box as="span" xcss={styles.agentAvatar12}>
					{agentAvatar}
				</Box> : agentAvatar}
		</Flex>;
};

/** Renders the agents participating in a session and an optional overflow count. */
export const SessionAgent = ({
  agents,
  showNames = true,
  isDefaultAgent = false,
  iconSize = 12,
  agentNameSpacing = 'space.050',
  additionalAgentCount,
  testId
}: SessionAgentProps): React.JSX.Element | null => {
  const {
    formatMessage
  } = useIntl();
  if (agents.length === 0 && !additionalAgentCount) {
    return null;
  }
  return <Box as="span" xcss={styles.agent} testId={testId}>
			{agents.map((agent, index) => {
      const agentName = agent.name;
      return <Box as="span" xcss={cx(agentNameSpacing === 'space.100' ? styles.identityWithWideNameSpace : styles.identity, index > 0 ? styles.spaced : undefined)} key={agent.id}>
						<AgentIdentityIcon agent={agent} iconSize={iconSize} isDefaultAgent={isDefaultAgent} isDecorative={showNames} />
						{showNames ? <Box as="span">{agentName}</Box> : null}
					</Box>;
    })}
			{additionalAgentCount && additionalAgentCount > 0 ? <Box as="span" xcss={agents.length > 0 ? styles.spaced : undefined} role="img" aria-label={formatMessage(messages.additionalAgentsLabel, {
      count: additionalAgentCount
    })}>
					<Text as="span" weight="medium">
						{formatMessage(messages.additionalAgents, {
          count: additionalAgentCount
        })}
					</Text>
				</Box> : null}
		</Box>;
};